import { AuthServiceError } from './AuthServiceError'

export class UnexpectedAuthError extends AuthServiceError {
  constructor(message?: string) {
    super(message ?? 'Unexpected error occurred', 'UNEXPECTED_AUTH_ERROR')
    this.name = 'UnexpectedAuthError'
  }
}
